export default "__VITE_ASSET__DXHogPmr__"